import React, { useState, useEffect, useMemo } from "react";
import { buildWhatsAppLink } from "../utils/whatsapp";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  const whatsappLink = useMemo(
    () =>
      buildWhatsAppLink({
        text: `Hello, I want to enquire about PC Care.\nPage: ${
          typeof window !== "undefined" ? window.location.href : ""
        }`,
      }),
    []
  );

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {visible && (
        <div className="fixed inset-x-0 z-[1000] bottom-[88px] lg:bottom-[30px] pointer-events-none">
          <div className="mx-auto w-full max-w-[1500px] px-2 flex items-center justify-between">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="scrollTopBtn whatsappBtn pointer-events-auto"
              style={{ position: "static" }}
              aria-label="Chat on WhatsApp"
            >
              <i className="fa-brands fa-whatsapp"></i>
            </a>
            <button
              onClick={scrollToTop}
              className="scrollTopBtn pointer-events-auto"
              style={{ position: "static" }}
              aria-label="Scroll to top"
            >
              <i className="fa-solid fa-arrow-up"></i>
            </button>
          </div>
        </div>
      )}
    </>
  );
};


export default ScrollToTopButton;
